import algoliasearch from 'algoliasearch';

// Production
const ALGOLIA_APP_ID = '7HASCTAZFV';
const ALGOLIA_API_KEY = 'e9e123a9a7acf580916e1cfbfefe8511';

const client = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_API_KEY, {
    protocol: 'https:'
});
const index = client.initIndex('products');

export default index;